module.exports = __webpack_public_path__ + "img/schema_omi_3b1.f6583242.svg";